import Moment from "moment";

import { openInNewTab } from "@lde/core_lde_vue";

import config from "@/config";
import Api from "@/modules/axios";

export default {
  state: {
    organismeActuel: null,
    isHorsMarche: false,
    exportingStatsMarche: localStorage.getItem("dateDemandeExportStatsMarche"),
  },
  getters: {
    organismeActuel(state) {
      return state.organismeActuel;
    },
    isHorsMarche(state) {
      return state.isHorsMarche;
    },
    isSpecificMarche: (state) => (marche) => state.organismeActuel?.marches?.some(
      ({ libelle }) => libelle.includes(marche),
    ),
    isAURA(state) {
      // #86caeftzk: Uniquement le 20c0544.
      return (
        ["26c0544"].includes(state.organismeActuel?.id_organisme.toLowerCase())
        // || ["22c2557"].includes(state.organismeActuel?.maitre_compta.toLowerCase())
      );
    },
    isGE(state, getters) {
      return getters.isSpecificMarche("Grand Est");
    },
    isPoitiers(state) {
      return state.organismeActuel?.maitre_compta === "26C0102";
    },
    isMarcheDemo(state) {
      return ["20C0127"].includes(state.organismeActuel?.maitre_compta);
    },
    isIDF(state, getters) {
      return getters.isSpecificMarche("Ile-de-France");
    },
    isNormandie(state, getters) {
      return getters.isMarcheDemo || state.organismeActuel?.maitre_compta === "22C2267";
    },
    isNimes(state) {
      return [
        "21C1700", "23C4556", "23C4557",
      ].includes(state.organismeActuel?.maitre_compta);
    },
    montrerModalAV(state, getters) {
      return getters.isMarcheDemo || getters.isGE || getters.isReunion || getters.isNormandie;
    },
    isReunion(state) {
      return state.organismeActuel.maitre_compta.toLowerCase() === "23c3991";
    },
    isMacon(state) {
      return state.organismeActuel.maitre_compta.toLowerCase() === "24c0239";
    },
    isRennesTest(state) {
      return state.organismeActuel.maitre_compta.toLowerCase() === "11c0095";
    },
    peutExporterCommande(state, getters) {
      return (
        getters.isReunion
          || getters.isGE
          || getters.isMarcheDemo
          || getters.isNormandie
          || getters.isNimes
          || getters.isMacon
          || getters.isRennesTest
      );
    },
    compatibleAdoptant(state, getters) {
      return getters.isGE || getters.isGMBH;
    },
    isSharedBudget(state, getters) {
      return getters.organismeActuel.catalogues_actifs.some((cat) => [2, 3].includes(cat.id_4d));
    },
    hasMail(state) {
      return state.organismeActuel?.marches?.some(({ email }) => email);
    },
    /**
     * Si la demande a été faite il y a moins d'un jour, on renvoie true.
     * @param {Object} state Contient le state.
     * @returns {Boolean}
     */
    exportingStatsMarche(state) {
      return state.exportingStatsMarche && Moment().diff(Moment(state.exportingStatsMarche), "days") < 1;
    },
  },
  mutations: {
    setOrganismeActuel(state, organismeActuel) {
      state.organismeActuel = organismeActuel;
      // FR : Si on n'a pas de marché, on est dans le hors-marché
      // GMBH : https://app.clickup.com/t/86c32f2uu Marché = "AO " dans catégorie ou type="Appel d'offre"
      if (organismeActuel) {
        if (state.isGMBH) {
          const marche = organismeActuel.infos.categorie.includes("AO ") || organismeActuel.type === "Appel d'offre";
          state.isHorsMarche = !marche;
        } else {
          state.isHorsMarche = organismeActuel.marches && !organismeActuel.marches.length;
        }
        localStorage.setItem("current_organisme_id", organismeActuel.id);
      } else {
        state.isHorsMarche = false;
        localStorage.setItem("current_organisme_id", null);
      }
    },
    setImgEtablissement(state, { image, image_from_library: lib }) {
      state.organismeActuel.infos.image = image;
      state.organismeActuel.infos.image_from_library = lib;
    },
    setExportingStatsMarche(state) {
      state.exportingStatsMarche = Moment().format();
      localStorage.setItem("dateDemandeExportStatsMarche", state.exportingStatsMarche);
    },
  },
  actions: {
    /**
     * Récupère les organismes accessibles.
     * @param {String} searchText Texte tapé dans l'input.
     */
    fetchOrganismes(store, searchText = "") {
      return new Promise((resolve, reject) => {
        Api().get(`/organisme/?search=${searchText}`)
          .then((res) => {
            resolve(res);
          })
          .catch((e) => reject(e));
      });
    },
    /**
     * Vérifie et met à jour le SIRET de l'organisme.
     * @param {Object} - ID et SIRET de l'organisme.
     */
    updateSiret(store, { idOrganisme, siret }) {
      return new Promise((resolve, reject) => {
        Api().post(`organisme/${idOrganisme}/set_siret/`, { siret })
          .then((res) => {
            store.commit("setOrganismeActuel", res.data);
            resolve(res);
          })
          .catch((e) => { reject(e); });
      });
    },
    /**
     * Envoie une demande d'export XLS des statistiques marché.
     */
    askExportStatsMarche() {
      openInNewTab(`${config.api.baseUrl}/organisme/export_xls/`);
    },
  },
};
